import React, { useEffect } from "react";
import { useFieldArray, useWatch } from "react-hook-form";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";

interface HeaderProps {
  control: any;
  errors: any;
  setValue: any;
}

const InvoiceSubForm: React.FC<HeaderProps> = ({
  control,
  errors,
  setValue,
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "sub_data",
  });

  const subData = useWatch({
    control,
    name: "sub_data",
  });


  useEffect(() => {
    if (!subData || subData.length === 0) {
      append({ count: "", price: "", tax_value: "", total: "" });
    }
 
  }, []);

  useEffect(() => {
    if (!subData) return;

    subData.forEach((row: any, index: number) => {
      const count = parseFloat(row?.count || "0");
      const price = parseFloat(row?.price || "0");
      const tax = parseFloat(row?.tax_value || "0");

      const subtotal = count * price;
      const taxAmount = tax ? subtotal * (tax / 100) : 0;
      const total = subtotal + taxAmount;

      setValue(`sub_data.${index}.total`, isNaN(total) ? "" : total.toFixed(2));
    });
  }, [subData, setValue]);


  const addRemoveButtons = (index: number): React.ReactNode => (
    <>
      <span className="icon">
        {index === fields.length - 1 && (
          <i
            className="fa fa-plus has-text-link smart-cursor"
            onClick={() =>
              append({ count: "", price: "", tax_value: "", total: "" })
            }
          />
        )}
      </span>
      <span className="icon">
        {fields.length > 1 && (
          <i
            className="fa fa-trash has-text-danger smart-cursor"
            onClick={() => remove(index)}
          />
        )}
      </span>
    </>
  );

 
  const getElements = (index: number): SdsFormElementProps[] => [
    {
      type: "TEXT_BOX",
      width: 2,
      name: `sub_data.${index}.type_hsn`,
      element: { size: "small" },
    },
    {
      type: "TEXT_BOX",
      width: 5,
      name: `sub_data.${index}.type_desc`,
      element: { size: "small" },
    },
    {
      type: "TEXT_BOX",
      width: 1,
      name: `sub_data.${index}.count`,
      element: { size: "small" },
    },
    {
      type: "TEXT_BOX",
      width: 1,
      name: `sub_data.${index}.price`,
      element: { size: "small" },
    },
    {
      type: "TEXT_BOX",
      width: 1,
      name: `sub_data.${index}.tax_value`,
      element: { size: "small" },
    },
    {
      type: "TEXT_BOX",
      width: 1,
      name: `sub_data.${index}.total`,
      element: {
        size: "small",
        disabled: true,
        readOnly: true,
      },
    },
    {
      type: "LABEL",
      width: 1,
      class_name: "has-text-centered p-2",
      name: `sub_data.${index}.addbuttons`,
      labelComponent: addRemoveButtons(index),
    },
  ];

  return (
    <>
      <div className="column is-6">
        <span className="is-size-5 has-text-weight-bold">Rates:</span>
      </div>

      <div className="sd-hims-input sd-hims-batch-form">
        <div className="columns is-gapless mb-0">
          <div className="column is-2 has-text-weight-bold">HSN</div>
          <div className="column is-5 has-text-weight-bold">Description</div>
          <div className="column is-1 has-text-weight-bold">Quantity</div>
          <div className="column is-1 has-text-weight-bold">Price</div>
          <div className="column is-1 has-text-weight-bold">Tax (%)</div>
          <div className="column is-1 has-text-weight-bold">Total</div>
        </div>

        {fields.map((field, index) => (
          <SdsForm
            key={field.id}
            elements={getElements(index)}
            errors={errors}
            control={control}
            className="mb-1 is-gapless"
          />
        ))}
      </div>
    </>
  );
};

export default InvoiceSubForm;
